<template>
  <div>
    <br/>
    <div style="overflow-x:auto;">
      <table style="column-width:50px; white-space:normal;">
        <thead>
        <tr class="navbar-fixed-top">
          <th>Listing</th>
          <th v-for="date in this.dates" :key="date">{{ date }}</th>
        </tr>
        <tr v-for="[key, val] in this.availabilities" :key="key">
          <div class="tooltip">
            <th>{{ getListingInfo(key)[0].title }}</th>
            <div class="tooltiptext">
              {{ getListingInfo(key)[0].address }}<br/><br/>
              ${{ getListingInfo(key)[0].dailyRoomPrice }}
            </div>
          </div>
          <th v-for="info in val" :key="info.date">{{ info.status }}</th>
        </tr>
        </thead>
      </table>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'AvailabilityPage',
  props: {},
  mounted() {
    axios.get(`${this.baseURL}/api/listing_calendar?operatorId=${this.operatorId}`)
        .then(res => {
          const entries = res.data.reduce(
              (entryMap, e) => entryMap.set(e.listingId, [...entryMap.get(e.listingId) || [], e]),
              new Map()
          );

          let availabilities = Array.from(entries)[0][1]
          let dates = [];
          for (let availability of availabilities) {
            dates.push(availability.date);
          }

          axios.get(`${this.baseURL}/api/listing?operatorId=${this.operatorId}`)
              .then(listingResult => listingResult.data)
              .then(listingsBody => {
                this.listings = listingsBody;

                this.dates = dates;
                this.availabilities = entries;
              });
        });
  },
  data: () => ({
    availabilities: [],
    dates: [],
    listings: [],
    operatorId: 'aba119b5-531c-416f-b854-31ec00c470a6',
    baseURL: 'https://crossover-api-dot-elite-pointer-290612.uc.r.appspot.com'
  }),
  methods: {
    getListingInfo(listingId) {
      return this.listings.filter(listing => listing.listingId == listingId);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 80%;
  border: 1px solid #ddd;
}

th, td {
  text-align: left;
  padding: 12px;
}

tr:nth-child(even) {
  background-color: #f2f2f2
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 180px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

</style>
